<template>
  <div class="icons-canvas">
    <img src="/statics/images/icons/accounts.svg" class="icons_l animTime_0_5" alt="">
    <img src="/statics/images/icons/cardPay.svg" class="icons_r animTime_1_6" alt="">
    <img src="/statics/images/icons/dynamics.svg" class="icons_l animTime_1h_6h" alt="">
    <img src="/statics/images/icons/shopping.svg" class="icons_r animTime_2_8" alt="">
    <img src="/statics/images/icons/checked.svg" class="icons_l animTime_3_8" alt="">
    <img src="/statics/images/icons/deals.svg" class="icons_l animTime_4_9" alt="">
    <img src="/statics/images/icons/business.svg" class="icons_l animTime_5_9" alt="">
  </div>
</template>

<script>
  export default {
    name: 'bg-animation'
  }
</script>

<style scoped>
  .icons-canvas {
    position: absolute;
    overflow: hidden;
    display: block !important;
    z-index: 0;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }

  .icons_l {
    position: absolute;
    width: 150px;
    height: 150px;
    top: 0;
    left: 0;
    transform: translate3d(0, 0, 0);
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate(-50%, -50%);
    filter: blur(10px);
    opacity: 0;
  }

  .icons_r {
    position: absolute;
    width: 150px;
    height: 150px;
    top: 0;
    left: 0;
    filter: blur(10px);
    opacity: 0;
  }

  @keyframes accountAnim {
    0% {
      width: 230px;
      height: 230px;
      left: 20%;
      top: 20%;
      opacity: 0;
      filter: blur(10px);
      animation-timing-function: linear;
    }
    60% {
      filter: blur(0px);
      animation-timing-function: linear;
    }
    100% {
      width: 70px;
      height: 70px;
      left: 50%;
      top: 50%;
      opacity: 0.3;
      filter: blur(0px);
      animation-timing-function: linear;
    }
  }

  @keyframes cardsAnim {
    0% {
      width: 200px;
      height: 200px;
      left: 70%;
      top: 80%;
      opacity: 0;
      filter: blur(10px);
      animation-timing-function: linear;
    }
    60% {
      filter: blur(0px);
      animation-timing-function: linear;
    }
    100% {
      width: 60px;
      height: 60px;
      left: 50%;
      top: 50%;
      opacity: 0.3;
      filter: blur(0px);
      animation-timing-function: linear;
    }
  }

  @keyframes dynamicsAnim {
    0% {
      width: 200px;
      height: 200px;
      left: 20%;
      top: 80%;
      opacity: 0;
      filter: blur(10px);
      animation-timing-function: linear;
    }
    60% {
      filter: blur(0px);
      animation-timing-function: linear;
    }
    100% {
      width: 60px;
      height: 60px;
      left: 50%;
      top: 50%;
      opacity: 0.3;
      filter: blur(0px);
      animation-timing-function: linear;
    }
  }

  @keyframes shoppingAnim {
    0% {
      width: 220px;
      height: 220px;
      left: 80%;
      top: 20%;
      opacity: 0;
      filter: blur(10px);
      animation-timing-function: linear;
    }
    60% {
      filter: blur(0px);
      animation-timing-function: linear;
    }
    100% {
      width: 70px;
      height: 70px;
      left: 50%;
      top: 50%;
      opacity: 0.3;
      filter: blur(0px);
      animation-timing-function: linear;
    }
  }

  @keyframes checkedAnim {
    0% {
      width: 220px;
      height: 220px;
      left: 40%;
      top: 0%;
      opacity: 0;
      filter: blur(10px);
      animation-timing-function: linear;
    }
    40% {
      filter: blur(0px);
      animation-timing-function: linear;
    }
    100% {
      width: 70px;
      height: 70px;
      left: 50%;
      top: 50%;
      opacity: 0.3;
      filter: blur(0px);
      animation-timing-function: linear;
    }
  }

  @keyframes dealsAnim {
    0% {
      width: 200px;
      height: 200px;
      left: 60%;
      top: 100%;
      opacity: 0;
      filter: blur(10px);
      animation-timing-function: linear;
    }
    50% {
      filter: blur(0px);
      animation-timing-function: linear;
    }
    100% {
      width: 50px;
      height: 50px;
      left: 50%;
      top: 50%;
      opacity: 0.3;
      filter: blur(0px);
      animation-timing-function: linear;
    }
  }

  @keyframes businessAnim {
    0% {
      width: 210px;
      height: 210px;
      left: 20%;
      top: 50%;
      opacity: 0;
      filter: blur(10px);
      animation-timing-function: linear;
    }
    50% {
      filter: blur(0px);
      animation-timing-function: linear;
    }
    100% {
      width: 70px;
      height: 70px;
      left: 50%;
      top: 50%;
      opacity: 0.3;
      filter: blur(0px);
      animation-timing-function: linear;
    }
  }

  .animTime_0_5 {
    animation: accountAnim 5.5s linear 0s 1 normal forwards;
    animation-iteration-count: infinite;
  }

  .animTime_1_6 {
    animation: cardsAnim 6s linear 1s 1 normal forwards;
    animation-iteration-count: infinite;
  }

  .animTime_1h_6h {
    animation: dynamicsAnim 7s linear 1.5s 1 normal forwards;
    animation-iteration-count: infinite;
  }

  .animTime_2_8 {
    animation: shoppingAnim 8s linear 2s 1 normal forwards;
    animation-iteration-count: infinite;
  }

  .animTime_3_8 {
    animation: checkedAnim 8s linear 3s 1 normal forwards;
    animation-iteration-count: infinite;
  }

  .animTime_4_9 {
    animation: dealsAnim 9s linear 4s 1 normal forwards;
    animation-iteration-count: infinite;
  }

  .animTime_5_9 {
    animation: businessAnim 9s linear 5s 1 normal forwards;
    animation-iteration-count: infinite;
  }
</style>
